import {
    GET_BUSINESS_BY_ID_ERROR,
    GET_BUSINESS_BY_ID_REQUEST, GET_BUSINESS_BY_ID_SUCCESS,
    GET_BUSINESS_BY_NAME_ERROR, GET_BUSINESS_BY_NAME_REQUEST, GET_BUSINESS_BY_NAME_SUCCESS,
    GET_BUSINESS_ERROR,
    GET_BUSINESS_REQUEST,
    GET_BUSINESS_SUCCESS,
    BUSINESS_CLEANUP
} from '../actions/actionTypes';

const INITIAL_STATE_BUSINESS_BY_NAME = {
    isFetching: false,
    data: {},
    error: false,
    errorMessage: ''
};

const INITIAL_STATE = {
    isFetching: false,
    data: [],
    paginator: {
        currentPage: 0,
        totalRecords: 0,
        from: 0,
        to: 0
    },
    error: false,
    errorMessage: '',
    searchInput: '',
    orderColumn: 'account_name',
    orderDirection: 'desc'
};

export const business = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_BUSINESS_REQUEST:
            return {
                ...state,
                isFetching: true,
                data: [],
                error: false,
                errorMessage: '',
                searchInput: '',
                orderColumn: action.orderColumn,
                orderDirection: action.orderDirection,
            };

        case GET_BUSINESS_SUCCESS:
            return {
                ...state,
                isFetching: false,
                data: action.business,
                paginator: {
                    currentPage: action.currentPage,
                    totalRecords: action.totalRecords,
                    from: action.from,
                    to: action.to
                },
                error: false,
                errorMessage: '',
                searchInput: action.searchInput,
                orderColumn: action.orderColumn,
                orderDirection: action.orderDirection
            };

        case GET_BUSINESS_ERROR:
            return {
                ...state,
                isFetching: false,
                data: [],
                error: true,
                errorMessage: action.payload,
                searchInput: '',
                orderColumn: '',
                orderDirection: '',
            };
        
        case BUSINESS_CLEANUP:
            return INITIAL_STATE

        default:
            return state;
    }
};

export const businessByName = (state = INITIAL_STATE_BUSINESS_BY_NAME, action) => {
    switch (action.type) {
        case GET_BUSINESS_BY_NAME_REQUEST:
            return {
                ...state,
                isFetching: true,
                data: {},
                error: false,
                errorMessage: ''
            };

        case GET_BUSINESS_BY_NAME_SUCCESS:
            return {
                ...state,
                isFetching: false,
                data: action.business,
                error: false,
                errorMessage: ''
            };

        case GET_BUSINESS_BY_NAME_ERROR:
            return {
                ...state,
                isFetching: false,
                data: {},
                error: true,
                errorMessage: action.payload
            };
        default:
            return state;
    }
};

export const businessById = (state = INITIAL_STATE_BUSINESS_BY_NAME, action) => {
    switch (action.type) {
        case GET_BUSINESS_BY_ID_REQUEST:
            return {
                ...state,
                isFetching: true,
                data: {},
                error: false,
                errorMessage: ''
            };

        case GET_BUSINESS_BY_ID_SUCCESS:
            return {
                ...state,
                isFetching: false,
                data: action.business,
                error: false,
                errorMessage: ''
            };

        case GET_BUSINESS_BY_ID_ERROR:
            return {
                ...state,
                isFetching: false,
                data: {},
                error: true,
                errorMessage: action.payload
            };
        default:
            return state;
    }
};
